import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '@services/auth';
import { map, take } from 'rxjs/operators';

export const AuthenticatedGuard: CanActivateChildFn = (_childRoute, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.checkAuth().pipe(
    take(1),
    map((isAuthenticated) => isAuthenticated || auth.logoutUrlTree(router, state.url))
  );
};
